/* eslint-disable @typescript-eslint/no-explicit-any */
import {useSelector} from "react-redux";
import {RootState} from "@/store";

export default function GeneralBody() {
    const selectedApplication = useSelector((state: RootState) => state.application.selectedApplication)
    return (
        <>

            <div>
                {selectedApplication ?
                    <div className="body-wrappe">
                        <div className="flex-1">
                            <div className="details">
                                <div className="detail-title">Application Name</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationName}
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title">Project ID</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationId}
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title">Application Status</div>
                                <div className="div-block-2">
                                    <div className="detail-description">
                                        {selectedApplication?.applicationStatus}
                                    </div>
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title"> Cloud Compute</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationCloudCompute}
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title">Framework</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationFramework}
                                </div>
                            </div>
                        </div>
                        <div className="flex-1">
                            <div className="details">
                                <div className="detail-title"> Cloud Provider</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationCloudProvider}
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title"> Cloud Provider</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationCloudProvider}
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title"> Architecture</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationArchitecture}
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title"> Language</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationLanguage}
                                </div>
                            </div>
                            <div className="details">
                                <div className="detail-title"> Database</div>
                                <div className="detail-description">
                                    {selectedApplication?.applicationDatabase}
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <p style={{
                        display: "flex",
                        marginTop: "10%",
                        justifyContent: "center",
                        fontStyle: "italic"
                    }}>Select an application to
                        preview</p>
                }
            </div>

        </>
    );
}
